import local_store from 'store'
import expirePlugin from 'store/plugins/expire'
import localStorageTester from './localStorageTester'

local_store.addPlugin(expirePlugin)
local_store.removeExpiredKeys()

const canUseLocalStorage = localStorageTester()

function get(key) {
	try {
		return local_store.get(key)
	} catch (e) {
		return null
	}
}

function set(key, value, expirationDate) {
	try {
		if (!canUseLocalStorage) {
			expirationDate = Date.now() + 1000 * 60 // one hour if localstorage is not being used
		} else if (!expirationDate) {
			expirationDate = Date.now() + 1000 * 60 * 60 * 24 * 15 // 15 days
		}
		return local_store.set(key, value, expirationDate)
	} catch (e) {}
}

export default {
	get,
	set,
}
